export default __webpack_public_path__ + "static/media/sensotrend_connect_install_uploader2.589626f2.png";